import Block from "./Block";
import { types } from "../graphql";
import { Link } from "react-router-dom";
import { Button } from "react-daisyui";

function ZoneContent({
  zone,
  currentUser,
  participants,
}: {
  zone: types.Zone;
  currentUser: types.User | null;
  participants: types.Participant[];
}) {
  return (
    <>
      <div>{zone.title}</div>
      <div>{participants.length ?? 0} participants</div>
      {zone.blocks
        .sort((a, b) => a.index - b.index)
        .map((block) => (
          <Block
            key={block.blockId}
            block={block}
            zone={zone}
            participants={participants}
            currentUser={currentUser}
          />
        ))}
      {zone.participation && zone.participation?.groups?.includes("owner") && (
        <Link to="/addBlock">
          <Button className="btn-primary">Add Block</Button>
        </Link>
      )}
    </>
  );
}

export default ZoneContent;
